import type { Camera } from '../../types'

interface Props {
  cameras: Camera[]
  assignedCameraIds: Set<string>
  onAssign: (cameraId: string) => void
  collapsed: boolean
  onToggle: () => void
}

export function StreamSidebar({ cameras, assignedCameraIds, onAssign, collapsed, onToggle }: Props) {
  function handleDragStart(e: React.DragEvent, cameraId: string) {
    e.dataTransfer.setData('text/camera-id', cameraId)
    e.dataTransfer.effectAllowed = 'move'
  }

  return (
    <div className={`bg-sidebar border-l border-card-border flex flex-col transition-all ${
      collapsed ? 'w-10' : 'w-56'
    }`}>
      <button
        onClick={onToggle}
        className="p-2 text-gray-500 hover:text-gray-900 text-sm border-b border-card-border transition-colors"
      >
        {collapsed ? '>' : '<'}
      </button>

      {!collapsed && (
        <div className="flex-1 overflow-y-auto p-2 space-y-1">
          <p className="text-xs uppercase tracking-wide text-brand-dark font-semibold px-2 py-1">
            Cameras ({cameras.length})
          </p>
          {cameras.map((cam) => {
            const assigned = assignedCameraIds.has(cam.id)
            return (
              <div
                key={cam.id}
                draggable
                onDragStart={(e) => handleDragStart(e, cam.id)}
                onClick={() => onAssign(cam.id)}
                className={`flex items-center gap-2 px-2 py-2 rounded-md text-sm cursor-pointer select-none transition-colors ${
                  assigned
                    ? 'bg-brand/10 text-brand'
                    : 'text-gray-600 hover:bg-sidebar-hover hover:text-gray-900'
                }`}
              >
                <span className={`w-2 h-2 rounded-full flex-shrink-0 ${
                  assigned ? 'bg-success' : 'bg-gray-300'
                }`} />
                <span className="truncate">{cam.name}</span>
                <span className="text-xs text-gray-600 ml-auto">#{cam.cam_number}</span>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
